import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-screen',
  templateUrl: './email-screen.component.html',
  styleUrls: ['./email-screen.component.scss']
})
export class EmailScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
